import { render, staticRenderFns } from "./NajavaKlient.vue?vue&type=template&id=b8c67d1e&scoped=true"
import script from "./NajavaKlient.vue?vue&type=script&lang=js"
export * from "./NajavaKlient.vue?vue&type=script&lang=js"
import style0 from "./NajavaKlient.vue?vue&type=style&index=0&id=b8c67d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c67d1e",
  null
  
)

export default component.exports